import { TARGET } from "../../constants/target.qwik.mjs";
import { isBrowser } from "../../functions/is-browser.qwik.mjs";
import { UPDATE_COOKIES_AND_STYLES_SCRIPT, UPDATE_VARIANT_VISIBILITY_SCRIPT } from "./inlined-fns.qwik.mjs";
const UPDATE_COOKIES_AND_STYLES_SCRIPT_NAME = "builderIoAbTest";
const UPDATE_VARIANT_VISIBILITY_SCRIPT_FN_NAME = "builderIoRenderContent";
const getVariants = (content) => Object.values((content == null ? void 0 : content.variations) || {}).map((variant) => ({
  ...variant,
  testVariationId: variant.id,
  id: content == null ? void 0 : content.id
}));
const checkShouldRenderVariants = ({ canTrack, content }) => {
  const hasVariants = getVariants(content).length > 0;
  if (!hasVariants)
    return false;
  if (!canTrack)
    return false;
  if (isBrowser())
    return false;
  return true;
};
const getIsHydrationTarget = (target) => target === "react" || target === "reactNative";
const isAngularSDK = TARGET === "angular";
const isHydrationTarget = getIsHydrationTarget(TARGET);
const getInitVariantsFnsScriptString = () => `
  window.${UPDATE_COOKIES_AND_STYLES_SCRIPT_NAME} = ${UPDATE_COOKIES_AND_STYLES_SCRIPT}
  window.${UPDATE_VARIANT_VISIBILITY_SCRIPT_FN_NAME} = ${UPDATE_VARIANT_VISIBILITY_SCRIPT}
  `;
const getUpdateCookieAndStylesScript = (variants, contentId) => `
  window.${UPDATE_COOKIES_AND_STYLES_SCRIPT_NAME}(
    "${contentId}",${JSON.stringify(variants)}, ${isHydrationTarget}, ${isAngularSDK}
  )`;
const getUpdateVariantVisibilityScript = ({ contentId, variationId }) => `window.${UPDATE_VARIANT_VISIBILITY_SCRIPT_FN_NAME}(
    "${variationId}", "${contentId}", ${isHydrationTarget}
  )`;
export {
  checkShouldRenderVariants,
  getInitVariantsFnsScriptString,
  getUpdateCookieAndStylesScript,
  getUpdateVariantVisibilityScript,
  getVariants
};
